import "./sectors-video.css";
import { manageLoopingVideo } from "./video-playback-manager";

const VIDEO_SRC = "/quantic-carthy.mp4";

function installSectorsVideo() {
  const section = document.querySelector("#sectors");
  if (!section) return false;
  if (section.querySelector(".sectors-video-stage")) return true;

  const inner = section.querySelector(":scope > .mx-auto");
  const copy = inner?.firstElementChild;
  const cards = copy?.nextElementSibling;
  if (!inner || !copy || !cards) return false;

  section.classList.add("sectors-video-section");
  inner.classList.add("sectors-video-layout");
  copy.classList.add("sectors-video-copy");
  cards.classList.add("sectors-video-cards");

  const stage = document.createElement("div");
  stage.className = "sectors-video-stage";
  stage.innerHTML = `
    <video
      class="sectors-video-element"
      src="${VIDEO_SRC}"
      muted
      loop
      playsinline
      preload="metadata"
      aria-label="Animation CARTHY autour des technologies quantiques et des secteurs exigeants"
    ></video>
    <div class="sectors-video-vignette" aria-hidden="true"></div>
  `;

  inner.insertBefore(stage, cards);

  const video = stage.querySelector("video");
  if (video) manageLoopingVideo(video, stage);

  return true;
}

function boot() {
  if (installSectorsVideo()) return;

  const observer = new MutationObserver(() => {
    if (installSectorsVideo()) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
